import { render, staticRenderFns } from "./OutletPriceAddEdit.vue?vue&type=template&id=7529ca94"
import script from "./OutletPriceAddEdit.vue?vue&type=script&lang=js"
export * from "./OutletPriceAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports